import React, { Fragment, useState } from 'react'
import Table from 'UI/Table'
import Filters from 'Features/Filters'
import { filteredVDCConsumption, groupByColumns, groupedVDCConsumption, columns } from './Data'
import SubComponent from './SubComponent'
import { map, startCase } from 'lodash'

const VDCConsumptionReport = ({ vdcs, customers, locations }) => {
  const [filters, changeFilters] = useState({
    customer: 'All',
    customerStatus: 'All',
    location: 'All',
    groupBy: 'global'
  })

  const groupByOptions = [
    { label: 'Global', value: 'global'},
    { label: 'Customer', value: 'customer_name'},
    { label: 'Location', value: 'location'},
  ]
  const customerStatuses = map(['live', 'historic', 'pending offboarding'], status => (
    { value: status, label: startCase(status) }
  ))

  return (
    <Fragment>
      <Filters filters={filters} onChange={changeFilters} className='mt-3'>
        <Filters.Select filterName='groupBy' label='Group By' options={groupByOptions} isMulti={false} />
        <Filters.Select filterName='customer' label='Customer' options={customers} />
        <Filters.Select filterName='customerStatus' label='Customer status' options={customerStatuses} />
        <Filters.Select filterName='location' label='Location' options={locations} />
      </Filters>
      <Table {...{
        data: groupedVDCConsumption(filters.groupBy, filteredVDCConsumption(filters, vdcs)),
        columns: groupByColumns(filters.groupBy, columns),
        SubComponent: (row) => SubComponent({ row, filters, vdcs, columns, showVMs: filters.groupBy === 'global' })
      }}
      />
    </Fragment>
  )
}

export default VDCConsumptionReport
